module.exports = __webpack_public_path__ + "img/picture_04.1b44572e.png";